// extracted by mini-css-extract-plugin
module.exports = {"container":"dialogHeader_container__yQx1o","icon":"dialogHeader_icon__d037H","text":"dialogHeader_text__TX8xh"};